import React from "react";
import { InputAdornment, OutlinedInput, Typography } from "@mui/material";

import { timeConfig } from "./helper";
import { StyledPickerStack } from "./styles";

const getInputAdornment = (adornment, position) =>
  adornment ? (
    <InputAdornment position={position}>
      {typeof adornment === "string" ? (
        <Typography variant="inputAdornment">{adornment}</Typography>
      ) : (
        adornment
      )}
    </InputAdornment>
  ) : null;

const HubTimePicker = ({
  time = {},
  handleTimeChange = () => { },
  fields = ["days", "hours", "minutes", "seconds"],
}) => {
  const handleChange = (e, time) =>
    handleTimeChange(time, Number(e.target.value));

  return (
    <StyledPickerStack fields={fields}>
      {fields.map((field) => (
        <OutlinedInput
          key={field}
          type="number"
          defaultValue={time[field] ?? 0}
          onBlur={(e) => handleChange(e, field)}
          inputProps={{ min: timeConfig[field].min, max: timeConfig[field].max }}
          endAdornment={getInputAdornment(timeConfig[field].label, "end")}
          sx={{
            "& .MuiOutlinedInput-input": {
              height: "auto", // fix spinner positioning
            },
          }}
        />
      ))}
    </StyledPickerStack>
  );
};

export default HubTimePicker;
